import { render, staticRenderFns } from "./SupplierEventList.vue?vue&type=template&id=2c3710fc&"
import script from "./SupplierEventList.vue?vue&type=script&lang=ts&"
export * from "./SupplierEventList.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierEventList.vue?vue&type=style&index=0&id=2c3710fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports